/* eslint-disable no-undef*/

const CRITEO_ID = 9289;
const TIMEOUT_MS = 3000;

const init = () => {
    window.Criteo = window.Criteo || {};
    window.Criteo.events = window.Criteo.events || [];

    const externalScript = '//static.criteo.net/js/ld/publishertag.js';
    const script = document.createElement("script");
    script.src = externalScript;
    script.async = true;
    script.setAttribute('fetchpriority', 'low');
    document.head.appendChild(script);
};

const fetch = (slots) => {
    const pushCallback = () =>
        window.Criteo.RequestBidsOnGoogleTagSlots(CRITEO_ID, () => {
            window.Criteo.SetDFPKeyValueTargeting();
            window?.googletag.pubads().refresh(slots);
        }, TIMEOUT_MS);
    window.Criteo.events.push(pushCallback);
};

const lazy = (slots) => {
    const pushCallback = () => {
        Criteo.RequestBidsOnGoogleTagSlots({
            networkId: CRITEO_ID,
            placements: slots,
            callback: () => {
                Criteo.SetDFPKeyValueTargeting();
                window?.googletag.pubads().refresh(slots);
            },
        }, TIMEOUT_MS);
    };
    window.Criteo.events.push(pushCallback);
};

export default {
    init,
    fetch,
    lazy,
};
